import { render, staticRenderFns } from "./FormUploadImage.vue?vue&type=template&id=1792ab77&"
import script from "./FormUploadImage.vue?vue&type=script&lang=js&"
export * from "./FormUploadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports